import { Feedback } from '@/components/feedback';
import { MY_ADS_PAGE, MY_ADS_TEST_IDS } from '../../utils';
import { AlertIcon } from './icons';

type TErrorStateConfig = {
	onRetry: () => void;
};

const ErrorState = ({ onRetry }: TErrorStateConfig) => (
	<Feedback
		dataTestId={MY_ADS_TEST_IDS.ERROR_STATE}
		actionTestId={MY_ADS_TEST_IDS.ERROR_STATE_RETRY_BUTTON}
		icon={<AlertIcon />}
		title={MY_ADS_PAGE.ERROR_STATE.TITLE}
		description={MY_ADS_PAGE.ERROR_STATE.DESCRIPTION}
		action={{
			label: MY_ADS_PAGE.ERROR_STATE.RETRY_BUTTON,
			onClick: onRetry,
			variant: 'secondary'
		}}
	/>
);

ErrorState.displayName = 'ErrorState';

export { ErrorState };
export type { TErrorStateConfig };
